import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';

import { environment } from '../../../../environments/environment';
import { CrudService } from '../../../crud/crud.service';

import { NotificationsService } from 'angular2-notifications';
import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable';
import * as jQuery from 'jquery';
import * as moment from "moment";
import { isObject } from 'util';
import { elementAt } from 'rxjs/operators';

import { HttpClient, HttpHeaders, HttpResponse  } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map} from 'rxjs/operators';
import { CurrencyPipe } from '@angular/common';
import { Mensaje } from 'app/mensaje';

@Component({
  selector: "app-pagos-formulario",
  templateUrl: "./formulario.component.html",
  styles: ["ngui-auto-complete {z-index: 999999 !important}"]
})
export class PagosFormularioComponent implements OnInit{
  tab = 1;
  tipo = [];
  facturacion_inicio = false;
  dato: FormGroup;
  form_pagos: any;
  form_movimientos_articulos: any;
  cargando = false;
  movimientos_articulos;
  codigo_barras_activo = false;
  caja_abierta = false;
  stocks = [];
  auto = 0;
  ticket;
  borrarCargando;
  error_venta = false;
  venta_ok = false;
  json;
  reimprimir = false;
  sin_resultado = "";

  empresa = localStorage.getItem("empresa");
  sucursal = localStorage.getItem("sucursal");
  permisos = JSON.parse(localStorage.getItem("permisos"));

  caja = localStorage.getItem("caja");
  public alumnos_term: string = `${environment.API_URL}/alumnos-auto?term=:keyword&empresa=${this.empresa}&sucursal=${this.sucursal}`;

  tieneid: boolean = false;
  time_cambio_cantidad_stoc;
  time_cambio_cantidad_articulo_key;
  time_pago;
  tamano = document.body.clientHeight;
  mensajeResponse: Mensaje = new Mensaje(true);

  public startValue: string;
  public selected: string;
  public options = {
    position: ["top", "right"],
    timeOut: 5000,
    lastOnBottom: true
  };

  url_nuevo = "../../nuevo";
  lista_colas = false;
  subtotal = 0;
  descuento = 0;
  iva = 0;
  total = 0;
  total_recibido = 0;
  cambio = 0;
  

  usuario;

  busqueda;
  objeto = {
    showProgressBar: true,
    pauseOnHover: true,
    clickToClose: true,
    maxLength: 3000
  };
  alumnos = {
    id: "",
    email:"",
    nombre:"",
    alumnos_metadatos: {
      nombre: ""
    },
    debe_materia: false,
    becas: {
      importe: 0
    },
    saldo_cuenta: 0,
    personas_rfcs: [],
    factura_rfc: {
      razon_social: "",
      rfc: "",
      codigo_postal: "",
      tipos_regimenes_fiscales_id: "",
    },
    baja: 0
  };

  documentos_no = false;
  configuracion;
  inscripciones = [];

  cupones = [];
  cupones_disponibles;
  importe_cupon = 0;

  carpeta;
  modulo;
  controlador;
  modulo_actual;
  constructor(
    private fb: FormBuilder,
    private crudService: CrudService,
    private route: ActivatedRoute,
    private _sanitizer: DomSanitizer,
    private notificacion: NotificationsService,
    private http: HttpClient,
  ) {

    
  }

  observableSource = (keyword: any): Observable<any[]> => {
    
    let url: string =  `${environment.API_URL}/alumnos-auto?term=${keyword}&empresa=${this.empresa}&sucursal=${this.sucursal}`
    if (keyword) {
      return this.http.get(url).pipe(map((response: HttpResponse<any>) => {
        let data: any = response;
        return data.data;
      }));
        
    } else {
      return Observable.bind([]);
    }
  }

  ngOnInit(): void {

    let url = location.href.split("/");
    this.carpeta = url[4];
    this.modulo = url[5];
    //this.modulo_actual = this.modulo.replace(/[-](?:^|\s)\S/g, function(a) { return a.toUpperCase(); }).replace(/[-_]+/g, ' ');

    let ctrl = "-" + this.modulo;
    this.controlador = ctrl.toLowerCase()
        // remplazar _ o - por espacios
        .replace(/[-_]+/g, ' ')
        // quitar numeros
        .replace(/[^\w\s]/g, '')
        // cambiar a mayusculas el primer caracter despues de un espacio
        .replace(/ (.)/g, function($1) {
            return $1.toUpperCase(); })
        // quitar espacios y agregar controller
        .replace(/ /g, '') + "Controller";

    // obtener los datos del usiario logueado almacen y clues
    this.configuracion = JSON.parse(localStorage.getItem("configuracion"));
    this.usuario = JSON.parse(localStorage.getItem("usuario"));
    this.caja = localStorage.getItem("caja");

    this.tipo["REINSCRIPCION"] = "Reinscripción";
    this.tipo["INSCRIPCION"] = "Inscripción";
    this.tipo["REINCORPORACION"] = "Reincorporación";

    if (this.caja && this.caja != "") {
      this.caja_abierta = true;
    }

    // inicializar el formulario reactivo
    this.iniciar_formulario();

    this.route.params.subscribe(params => {
      if (params["id"]) {
        this.tieneid = true;
      }
    });
    this.selected = "";
    this.startValue = "";
    // variable para crear el array del formulario reactivo
    this.form_pagos = {
      pagos_targetas: this.fb.group({
        banco: [""],
        folio: [""]
      }),
      tipos_metodos_pagos_id: ["PUE", [Validators.required]],
      tipos_formas_pagos_id: ["01", [Validators.required]],
      importe: [this.dato.controls["total"].value > 0 ? this.dato.controls["total"].value : 0, [Validators.required] ],
      paga_con: ["", [Validators.required]],
      cambio: ["", [Validators.required]],
      comentarios: [""]
    };
    this.agregar_forma_pago(
      <FormArray>this.dato.controls.pagos,
      this.form_pagos
    );
    // Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();
    setTimeout(() => {
      (<HTMLInputElement>document.getElementById("buscarArticulo")).focus;
    }, 100);

    ////////// facturacion
    this.iniciar_form_factura("D10");
  }
  iniciar_formulario() {
    this.dato = this.fb.group({
      id: [""],
      es_pago_repeticion: [0],
      tipos_movimientos_id: [2],
      personas_id: [this.alumnos.id],
      pagos_publicos_id: [""],
      pagos_cuentas: [0],
      subtotal: [0],
      descuento: [0],
      iva: [0],
      requiere_factura: [0],
      pendiente_factura: [0],
      uso_cfdi: ["D10"],
      cajas_id: [this.caja],
      total: [0, [Validators.required]],
      total_recibido: [0, [Validators.required]],
      cambio: [""],
      devolucion_cambio: [this.configuracion.sucursal.devolver_cambio],
      codigo: [""],
      folio: [""],
      barcode: [""],
      cuentas_bancarias_id: [""],
      status_movimientos_id: [1],
      status_introduccion: [""],
      status_pago: [""],
      fecha: [""],
      created_at: [""],
      comentarios: [""],
      personas_cupones_id: [""],
      valido: ["", [Validators.required]],
      pagos: this.fb.array([]),
      movimientos_articulos: this.fb.array([]),
      personas: this.fb.group({
        nombre: [""],
        email:[""],
        nombre_completo: [""],
        apellido_materno: [""],
        apellido_paterno: [""]
      })
    });
  }
  /**
   * Este método formatea los resultados de la busqueda en el autocomplte
   * @param data resultados de la busqueda
   * @return void
   */
  autocompleListFormatter = (data: any) => {

    if (this.auto == 0) {
      $("ngui-auto-complete").attr(
        "style",
        $("ngui-auto-complete").attr("style") + "z-index:99999 !important; height:60vh !important;"
      );
    }
    let html = `
    <div class="card" >
      <div class="card-content">
        <div class="media">
          <div class="media-content">
            <h4 style="font-size:1.5em; color:#292929; font-weight: 600;">
            ${data.nombre} ${
      data.apellido_paterno
    } ${data.apellido_materno}
            <small style="font-size: .5em; font-style: italic;">
           ${data.email}
            </small></h4>
            <h6>
              <strong>CURP: </strong> ${
                data.curp
              } <strong>Tutor: </strong> ${data.alumnos_metadatos.tutor_nombre}
              `;
              
      // MATRICULA Y CARRERA  MATRICULA Y CARRERA  MATRICULA Y CARRERA  MATRICULA Y CARRERA  MATRICULA Y CARRERA 

    html += `<label class="tag is-success" >Matrícula: <strong>${
      data.matricula
      } </strong> </label>`;

    html += `<label class="tag is-warning" >  ${
      data.carreras.nombre
      }</label>`;
      // MATRICULA Y CARRERA  MATRICULA Y CARRERA  MATRICULA Y CARRERA  MATRICULA Y CARRERA  MATRICULA Y CARRERA 

    html += `
            </h6>
          </div>
        </div>
      </div>
    </div>`;
    this.auto++;
    
    return this._sanitizer.bypassSecurityTrustHtml(html);
  };

  cambiar_precio(p, i, modelo) {
    p = p.srcElement.value;
    modelo[i].controls["precio_unitario"].patchValue(
      modelo[i].get("articulos").value.articulos_precios[p].precio
    );
    this.calcular_importe_articulo();
  }
  /**
   * Este método agrega los lostes del modal a el modelo que se envia a la api
   * @return void
   */
  select_articulo_autocomplete(data) {
    if (isObject(data)) {
      this.venta_ok = false;
      this.cargando = true;
      this.auto = 0;
      // obtener el formulario reactivo para agregar los elementos
      const ctrl = <FormArray>this.dato.controls["movimientos_articulos"];
      if (ctrl.controls) {
        if (typeof ctrl.controls.length == "number") {
          while (ctrl.length) {
            ctrl.removeAt(ctrl.length - 1);
          }
          ctrl.reset();
        }
      }

      if (!data.alumnos_metadatos.hasOwnProperty("foto")) {
        data.alumnos_metadatos.foto = "";
      }
      if (!data.alumnos_metadatos.hasOwnProperty("avatar")) {
        data.alumnos_metadatos.avatar = "";
      }

      this.alumnos = data;
      this.alumnos.factura_rfc = data.personas_rfcs[0];

      this.cargarDatos(this.alumnos.id);
      (<HTMLInputElement>document.getElementById("buscarArticulo")).value = "";
    }
  }
  cargarDatos(id) {
    this.tamano = document.body.clientHeight;
    this.inscripciones = [];
    this.cargando = true;
    this.crudService.ver(id, "pago").subscribe(
      resultado => {
        if (typeof resultado.grupos_siguiente == "string") {
          this.sin_resultado = resultado.grupos_siguiente;
          setTimeout(() => {
            this.sin_resultado = "";
          }, 3500);
        }
        if (resultado.status == 200) {
          this.alumnos.saldo_cuenta = resultado.saldo_cuenta;
          this.inscripciones = resultado.data;
          this.cupones_disponibles = resultado.cupones;
          this.dato.controls.personas_id.patchValue(this.alumnos.id);
        } else {
          this.sin_resultado = resultado.messages;
          setTimeout(() => {
            this.sin_resultado = "";
          }, 3500);
        }
        this.iniciar_formulario();
        this.agregar_forma_pago(
          <FormArray>this.dato.controls.pagos,
          this.form_pagos
        );
        this.cargando = false;
      },
      error => {
        this.cargando = false;
        setTimeout(() => {}, 2500);
      }
    );
  }

  agregar_articulos(item, articulos_id) {
    let beca = item.beca;

    if (typeof beca == "undefined" || beca == null) {
      beca = 0;
    }
    if (item.beca_porcentaje) {
      beca = item.importe * (beca / 100);
    }

    let articulo = item;
    articulo.nombre = "Recargo";
    articulo.codigo_barras = 5;

    if (this.cupones_disponibles[articulos_id]) {
      this.cupones = this.cupones_disponibles[articulos_id];
    } else {
      this.cupones = [];
      this.importe_cupon = 0;
      this.dato.controls.personas_cupones_id.patchValue("");
    }

    let nombre = "Reinscripción";
    if (articulos_id == "12a00afca32cafa9f493f73f2b7f8bcf") {
      nombre = "Colegiatura";

      if (item.movimientos_colegiaturas.length > 0) beca = 0;
    } else {
      if (item.movimientos_inscripciones.length > 0) beca = 0;
    }

    const ctrl = <FormArray>this.dato.controls["movimientos_articulos"];

    let posicion = ctrl.length;
    if (posicion < 0) {
      posicion = 0;
    }
    item.posicion = posicion;
    item.agregado = true;

    let recargo = parseFloat(articulo.recargo_importe);

    let movimientos_articulos = {
      articulos_id: [articulos_id, [Validators.required]],
      nombre: [nombre, [Validators.required]],
      cantidad: [1, [Validators.required]],
      cantidad_restante: [1],
      precio_unitario: [item.importe, [Validators.required]],
      articulos_precios_id: [""],
      importe: [item.importe, [Validators.required]],
      descuento: [beca],
      precio_con_descuentos: [item.importe - beca],
      iva_porcentaje: [0],
      iva_cantidad: [0],
      subtotal: [item.importe, [Validators.required]],
      periodos_escolares_colegiaturas_id:
        item.periodos_escolares_colegiaturas_id,
      recargo: recargo,
      articulos: articulo,
      created_at: [item.created_at]
    };
    this.dato.controls.fecha.patchValue(item.created_at);
    item.recargo = recargo;
    ctrl.push(this.fb.group(movimientos_articulos));

    if (recargo > 0 ) {
      let hacer = true;
      if (articulo.movimientos_colegiaturas){
        if (articulo.movimientos_colegiaturas.length == 0){
          hacer = true;
        }else false;
      }
      if(hacer)
        this.agregar_recargo(articulo, articulos_id);
    }

    this.calcular_importe_articulo();
  }

  pagar_materia(item, articulos_id) {
    
    this.dato.controls.es_pago_repeticion.patchValue(1);

    if (this.cupones_disponibles[articulos_id]) {
      this.cupones = this.cupones_disponibles[articulos_id];
    } else {
      this.cupones = [];
      this.importe_cupon = 0;
      this.dato.controls.personas_cupones_id.patchValue("");
    }

    let articulo = item;

    const ctrl = <FormArray>this.dato.controls["movimientos_articulos"];

    let posicion = ctrl.length;
    if (posicion < 0) {
      posicion = 0;
    }
    item.posicion = posicion;
    item.agregado = true;

    let recargo = 0;

    let movimientos_articulos = {
      articulos_id: [articulos_id, [Validators.required]],
      nombre: ['Repeticion de materia', [Validators.required]],
      cantidad: [1, [Validators.required]],
      cantidad_restante: [1],
      precio_unitario: [item.importe, [Validators.required]],
      articulos_precios_id: [""],
      importe: [item.importe, [Validators.required]],
      descuento: [0],
      precio_con_descuentos: [item.importe - 0],
      iva_porcentaje: [0],
      iva_cantidad: [0],
      subtotal: [item.importe, [Validators.required]],
      periodos_escolares_colegiaturas_id: item.periodos_escolares_colegiaturas_id,
      recargo: recargo,
      articulos: articulo,
      created_at: [item.created_at]
    };
    this.dato.controls.fecha.patchValue(item.created_at);
    item.recargo = recargo;
    ctrl.push(this.fb.group(movimientos_articulos));


    this.calcular_importe_articulo();
  }

  agregar_recargo(recar, articulos_id) {
    const ctrl = <FormArray>this.dato.controls["movimientos_articulos"];

    let recargo = parseFloat(recar.recargo_importe);

    let articulor = recar;
    (articulor.nombre = "Recargo"), (articulor.codigo_barras = 5);

    let movimientos_articulos_recargo = {
      articulos_id: ["21765cdac7cde1ab1a7ba6857e06d2a3", [Validators.required]],
      cantidad: [1, [Validators.required]],
      nombre: ["Recargo", [Validators.required]],
      cantidad_restante: [1],
      precio_unitario: [recargo, [Validators.required]],
      articulos_precios_id: [""],
      importe: [recargo, [Validators.required]],
      descuento: [0, [Validators.required]],
      precio_con_descuentos: [recargo, [Validators.required]],
      iva_porcentaje: [0, [Validators.required]],
      iva_cantidad: [0, [Validators.required]],
      subtotal: [recargo, [Validators.required]],
      periodos_escolares_colegiaturas_id:
        articulor.periodos_escolares_colegiaturas_id,
      articulos: articulor,
      created_at: [recar.created_at]
    };
    ctrl.push(this.fb.group(movimientos_articulos_recargo));
  }

  quitar_articulos(modelo, item, index) {
    this.cupones = [];
    this.importe_cupon = 0;
    this.dato.controls.personas_cupones_id.patchValue("");
    modelo.removeAt(0);

    if (item.recargo > 0) {
      modelo.removeAt(0);
    }

    item.posicion = "";
    item.agregado = false;
    this.dato.controls.pagos = this.fb.array([]);
    this.agregar_forma_pago(
      <FormArray>this.dato.controls.pagos,
      this.form_pagos
    );

    this.calcular_importe_articulo();
  }

  quitar_articulos_colegiatura(modelo, item, val, index) {
    this.cupones = [];
    this.importe_cupon = 0;
    this.dato.controls.personas_cupones_id.patchValue("");
    let i = modelo.value.length;
    const total = val.posicion;
    while (i >= total) {
      modelo.removeAt(i);
      if (item[i]) {
        if (item[i].recargo > 0) {
          modelo.removeAt(i);
        }
        item[i].posicion = "";
      }
      i--;
    }

    for (let i = index; i < item.length; i++) {
      item[i].agregado = false;
    }

    this.dato.controls.pagos = this.fb.array([]);
    this.agregar_forma_pago(
      <FormArray>this.dato.controls.pagos,
      this.form_pagos
    );

    this.calcular_importe_articulo();
  }

  asignar_cupon(cupon, op) {
    if (op) {
      this.importe_cupon = parseFloat(cupon.importe);
      this.dato.controls.personas_cupones_id.patchValue(cupon.id);
    } else {
      this.dato.controls.personas_cupones_id.patchValue("");
    }

    const ctrl = <FormArray>this.dato.controls["movimientos_articulos"];
    const item = <FormGroup>ctrl.controls[0];
    let total = 0;
    if (op) {
      total = parseFloat(item.controls.descuento.value) + this.importe_cupon;
    } else {
      total = parseFloat(item.controls.descuento.value) - this.importe_cupon;
    }
    item.controls.descuento.patchValue(total);
    if (op == 0) {
      this.importe_cupon = 0;
    }
    this.calcular_importe_articulo();
  }

  calcular_importe_articulo() {
    // sumamos las cantidades
    let total = 0;
    let c = 0;
    let restante = 0;
    let descuento = 0;

    this.dato.get("movimientos_articulos").value.forEach(element => {
      let importe_desc = element.cantidad * element.precio_unitario;
      element.importe = element.cantidad * element.precio_unitario;

      if (element.descuento > 0) {
        let desc = parseFloat(element.descuento);
        element.precio_con_descuentos = importe_desc - desc;
        descuento += desc;
      } else {
        element.precio_con_descuentos = element.importe;
      }

      total = total + element.cantidad * element.precio_unitario;
      const ma = <FormArray>this.dato.controls.movimientos_articulos;
      const it = <FormGroup>ma.controls[c];
      it.controls.importe.patchValue(element.importe);
      it.controls.precio_con_descuentos.patchValue(
        element.precio_con_descuentos
      );
      c++;
    });

    let importe: any= 0;
    let cambio = 0;
    let i = 0;
    let efectivo = false;
    const pagos = <FormArray>this.dato.controls["pagos"];
    this.dato.get("pagos").value.forEach(element => {
      importe = importe + element.paga_con;
      if (element.tipos_formas_pagos_id == "01") efectivo = true;
    });

    this.dato.controls["subtotal"].patchValue(total);
    this.dato.controls["descuento"].patchValue(descuento);
    this.dato.controls["total"].patchValue(total - descuento);
    this.dato.controls["total_recibido"].patchValue(importe);
    if (efectivo) {
      let cambiox = importe - (total - descuento);
      if(cambiox<0){
        cambiox=0;
      }
      this.dato.controls["cambio"].patchValue(cambiox);
    } else {
      this.dato.controls["cambio"].patchValue(0);
    }

    if (this.json) {
      this.json.subtotal = total;
      this.json.descuento = descuento;
      this.json.total = total - descuento;
      this.json.total_recibido = importe;
      if (efectivo) this.json.cambio = importe - (total - descuento);
      else this.json.cambio = 0;
    }
    importe = parseFloat(importe);
    if (importe >= total - descuento) {
      this.dato.controls["valido"].patchValue("si");

      if (restante > 0) {
        this.dato.controls["valido"].patchValue("");
        this.notificacion.alert(
          "Cantidad surtida",
          "Verifique que las cantidades coincidan con lo solicitado: ",
          this.objeto
        );
      }
    } else if (importe > 0) {
      this.dato.controls["valido"].patchValue("si");
    } else {
      this.dato.controls["valido"].patchValue("");
    }

    const imp = <FormGroup>pagos.controls[pagos.controls.length - 1];
    if (imp) {
      const pago = <FormArray>this.dato.controls.pagos;
      let p = pago.length - 1;
      if (p > 0) {
        pago.controls[p]["controls"]["importe"].patchValue(
          Math.abs(pago.controls[p - 1]["controls"]["cambio"].value)
        );
      } else {
        if (imp.controls.paga_con.value == "") {
          imp.controls.importe.patchValue(total - descuento);
        }
      }
    }
    let cambios = 0;
    if (efectivo) cambios = 0;
    else cambios = importe - (total - descuento);
    this.dato.get("pagos").value.forEach(element => {
      const imp = <FormGroup>pagos.controls[i];
      if (element.paga_con > 0 && efectivo) {
        cambios = this.dato.controls.cambio.value;
      }
      imp.controls["cambio"].patchValue(cambios);
      i++;
      cambios = Math.abs(cambios);
    });
  }

  validar_cantidad_pago(event, modelo, cantidad, tipo, i) {
    if (
      event.key != "ArrowLeft" &&
      event.key != "ArrowRight" &&
      event.key != "ArrowUp" &&
      event.key != "ArrowDown" &&
      event.key != "."
    ) {
      clearTimeout(this.time_pago);
      this.time_pago = setTimeout(() => {
        this.validar_pago(event, modelo, cantidad, tipo, i);
      }, 800);
    }
  }

  validar_pago(event, modelo, cantidad, tipo, i) {
    let success = true;
    if (tipo == "min") {
      if (modelo.value < cantidad) {
        success = false;
      }
    }
    if (tipo == "max") {
      if (modelo.value > cantidad) {
        success = false;
      }
    }
    /*
    if (!success) {
      modelo.patchValue(cantidad);
    }*/

    this.calcular_importe_articulo();
  }
 
  reset_form() {
    this.selected = "";
    this.startValue = "";
    this.dato.reset();
    for (let item in this.dato.controls) {
      const ctrl = <FormArray>this.dato.controls[item];
      if (ctrl.controls) {
        if (typeof ctrl.controls.length == "number") {
          while (ctrl.length) {
            ctrl.removeAt(ctrl.length - 1);
          }
          ctrl.reset();
        }
      }
    }
    this.dato.controls.tipos_movimientos_id.patchValue(2);
    this.dato.controls.status_movimientos_id.patchValue(1);
    this.agregar_forma_pago(
      <FormArray>this.dato.controls.pagos,
      this.form_pagos
    );
  }

  agregar_forma_pago(modelo: FormArray, formulario) {
    (<FormArray>modelo).push(this.fb.group(formulario));

    const pago = <FormArray>this.dato.controls.pagos;

    let p = pago.length - 1;
    if (p > 0) {
      pago.controls[p]["controls"]["importe"].patchValue(
        Math.abs(pago.controls[p - 1]["controls"]["cambio"].value)
      );
    }
  }

  cambiar_rfc(val) {
    this.alumnos.factura_rfc = val;
  }

  enviar() {
    this.cargando = true;
    this.json = this.dato.getRawValue();
    this.json.alumnos = this.alumnos;
    document
      .getElementById("confirmarLiquidacion")
      .classList.remove("is-active");

    if (this.dato.get("id").value > 0) {
      this.crudService
        .editar(this.dato.get("id").value, this.json, "pago")
        .subscribe(
          resultado => {

            this.enviar_ticket(this.json, resultado);
            if (resultado.status == 200){
              this.venta_ok = true;

              setTimeout(() => {
                this.venta_ok = false;
              }, 1500);
            }
          },
          error => {
            this.cargando = false;
            this.error_venta = true;
          }
        );
    } else {
      this.crudService.crear(this.json, "pago").subscribe(
        resultado => {
          this.enviar_ticket(this.json, resultado);
          if (resultado.status == 200) {
            this.venta_ok = true;

            setTimeout(() => {
              this.venta_ok = false;
            }, 1500);
            this.reset_form();
          }
        },
        error => {
          this.cargando = false;
          this.error_venta = true;
          setTimeout(() => {
            this.error_venta = false;
          }, 2500);
        }
      );
    }
  }

  enviar_ticket(json, resultado = null) {
    this.cargando = false;

    document.getElementById("quitar_cola").click();
    setTimeout(() => {
      this.venta_ok = false;
    }, 3000);
    this.json = resultado ? resultado.data : json;

    this.error_venta = false;
    if (resultado) {
      if (resultado.status == 200) {
        document.getElementById("cargar_datos_actualizar").click();
        document.getElementById("guardado_exito").classList.add("is-active");
        this.inscripciones = resultado.data;
        this.dato.controls.personas_id.patchValue(this.alumnos.id);

        ////// facturacion si require factura y no se deja en pendiente
        this.iniciar_form_factura(this.dato.get("uso_cfdi").value);
        if (resultado.facturacion.requiere_factura) {
          this.ventas_facturar = [];
          this.cargar_factura(false, resultado);
        }
      } else {
        this.sin_resultado = resultado.messages;
        setTimeout(() => {
          this.sin_resultado = "";
        }, 3500);
      }
      this.iniciar_formulario();
      this.agregar_forma_pago(
        <FormArray>this.dato.controls.pagos,
        this.form_pagos
      );
      this.cargando = false;
    }

  }

  mensaje(cuentaAtras: number = 6, posicion: any[] = ["bottom", "left"]): void {
    let objeto = {
      showProgressBar: true,
      pauseOnHover: false,
      clickToClose: true,
      maxLength: this.mensajeResponse.texto.length
    };

    this.options = {
      position: posicion,
      timeOut: cuentaAtras * 1000,
      lastOnBottom: true
    };
    if (this.mensajeResponse.clase == 'alert')
      this.notificacion.alert(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'success')
      this.notificacion.success(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'info')
      this.notificacion.info(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'warning' || this.mensajeResponse.clase == 'warn')
      this.notificacion.warn(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

    if (this.mensajeResponse.clase == 'error' || this.mensajeResponse.clase == 'danger')
      this.notificacion.error(this.mensajeResponse.titulo, this.mensajeResponse.texto, objeto);

  }

  

  enviarTicketDos(item:any){
    let empresa = this.configuracion.empresa.nombre
    let sucursal = this.configuracion.sucursal.nombre
    let sucursal_direccion = this.configuracion.sucursal.direccion
    let rfc = this.configuracion.sucursal.facturacion.rfc
    
    let general = {}
    let articulos = []
    for (let index = 0; index < item.movimientos.movimientos_articulos.length; index++) {
      const element = item.movimientos.movimientos_articulos[index];
      articulos.push({
        'concepto': element.articulos.nombre,
        'cantidad': element.cantidad,
        'importe':this.convertirMoneda(element.precio_unitario),
        'descuento':this.convertirMoneda(element.descuento),
        'importe_descuento':this.convertirMoneda(element.precio_con_descuentos)
      })
    }
    
    general = {
     
      'body_email': {
        'configuracion': {
          'empresa': empresa,
          'sucursal': sucursal,
          'direccion': sucursal_direccion,
          'rfc': rfc
        },
        'codigo':item.movimientos.codigo,
        'fecha':item.created_at,
        'persona':item.movimientos.personas.nombre_completo,
        'correo': this.alumnos.email,
        'movimientos':articulos,
        'subtotal':this.convertirMoneda(item.movimientos.subtotal),
        'descuentos':this.convertirMoneda(item.movimientos.descuento),
        'total': this.convertirMoneda(item.movimientos.total),
        'forma_pago':item.movimientos.pagos[0].tipos_formas_pagos.nombre.toUpperCase() + ": " + this.convertirMoneda(item.movimientos.pagos[0].paga_con), 
        'cambio': this.convertirMoneda(item.movimientos.pagos[0].cambio),
        'tipo_pago':item.movimientos.pagos[0].tipos_metodos_pagos.nombre.toUpperCase()
      }
    }

  
  // console.log(general);

  

  this.http.post('https://cum.api.managerescolar.app/api/v1/ticket-email',general).subscribe(res =>{
   
  this.mensajeResponse.titulo = 'Envio de Correo';
  this.mensajeResponse.texto = 'Correo enviado correctamente';
  this.mensajeResponse.mostrar = true;
  this.mensajeResponse.clase = 'success';
  this.mensaje(3);
    // console.log(res);
    
    
  },(e)=>{
    console.log(e);

    this.mensajeResponse.titulo = 'Envio de Correo';
    this.mensajeResponse.texto = 'El envio del correo fallo';
    this.mensajeResponse.mostrar = true;
    this.mensajeResponse.clase = 'error';
    this.mensaje(3);
  })
  
  }
  /////////////////////////////////// facturacion ///////////////////////////////////
  facturacion;

  error_timbre = false;
  valido = false;
  error_busqueda = false;
  errores = [];
  todas_ventas = false;
  activarRfc = false;
  activarUso = false;
  seleccionar_iva = false;

  codigo = "";
  cliente = "";
  facturas_mes = [];
  requiere_factura = 1;

  ventas_facturar = [];
  ventas_mes_facturar = [];
  desglosar_impuestos = true;
  con_impuesto = true;
  VERSION_CFDI = environment.VERSION_CFDI;
  CFDI_PATH = environment.CFDI_PATH;

  date = new Date();

  abrir_facturacion() {
    this.facturacion.Receptor.Rfc = this.alumnos.factura_rfc.rfc;
    this.facturacion.Receptor.Nombre = this.alumnos.factura_rfc.razon_social;

    this.facturacion.Receptor.RegimenFiscalReceptor = this.alumnos.factura_rfc.tipos_regimenes_fiscales_id;
    this.facturacion.Receptor.DomicilioFiscalReceptor = this.alumnos.factura_rfc.codigo_postal;
    document.getElementById("verPdf").classList.add("is-active");
  }

  iniciar_form_factura(uso_cfdi) {
    this.facturacion = {
      Version: this.VERSION_CFDI,
      Serie: this.configuracion.sucursal.facturacion.serie,
      Folio: "",
      Fecha: moment
        .utc(
          moment(
            new Date(
              this.date.getTime() - this.date.getTimezoneOffset() * 60000
            )
          )
        )
        .format(),
      Sello: "",
      NoCertificado: "",
      Certificado: "",
      SubTotal: 0,
      Moneda: this.configuracion.sucursal.moneda,
      Total: 0,
      TotalLetra: "",
      TipoDeComprobante: "I",
      FormaPago: "",
      MetodoPago: "",
      CondicionesDePago: "Contado",
      Descuento: 0,
      LugarExpedicion: this.configuracion.sucursal.facturacion.lugar_expedicion,
      CfdiRelacionados: { TipoRelacion: "", CfdiRelacionado: [{ UUID: "" }] },
      Emisor: {
        Rfc: this.configuracion.sucursal.facturacion.rfc,
        Nombre: this.configuracion.sucursal.facturacion.razon_social,
        RegimenFiscal: this.configuracion.sucursal.facturacion.regimen_fiscal
      },
      Receptor: { Rfc: "", Nombre: "", UsoCFDI: uso_cfdi, RegimenFiscalReceptor: "", DomicilioFiscalReceptor: "" },
      Conceptos: { Concepto: [] },
      Impuestos: {
        TotalImpuestosTrasladados: 0,
        TotalImpuestosRetenidos: 0,
        Traslados: [],
        Retenciones: []
      },
      Complemento: {
        TimbreFiscalDigital: {
          FechaTimbrado: "",
          UUID: "",
          NoCertificadoSAT: "",
          SelloCFD: "",
          SelloSAT: "",
          CadenaOriginal: "",
          qr: ""
        }
      }
    };

    this.facturacion_inicio = true;
  }

  cargar_factura(es_publico, resultado) {
    if (document.getElementById("cerrarOtrosPagos")){
      document.getElementById("cerrarOtrosPagos").click();
    }
    if (resultado.status === 200) {
      this.facturacion.Receptor.Rfc = this.alumnos.factura_rfc.rfc;
      this.facturacion.Receptor.Nombre = this.alumnos.factura_rfc.razon_social;

      this.facturacion.Receptor.RegimenFiscalReceptor = this.alumnos.factura_rfc.tipos_regimenes_fiscales_id;
      this.facturacion.Receptor.DomicilioFiscalReceptor = this.alumnos.factura_rfc.codigo_postal;

      this.valido = true;

      this.ventas_facturar.push(resultado.facturacion.id);

      let forma_pago = resultado.facturacion.pagos[0].tipos_formas_pagos_id;

      // datos generales
      this.facturacion.Serie = this.configuracion.sucursal.facturacion.serie;
      this.facturacion.Folio = resultado.facturacion.folio;
      this.facturacion.Fecha = moment
        .utc(
          moment(
            moment
              .utc(
                moment(
                  new Date(
                    this.date.getTime() - this.date.getTimezoneOffset() * 60000
                  )
                )
              )
              .format()
          )
        )
        .format();
      this.facturacion.FormaPago = forma_pago;
      this.facturacion.MetodoPago =
        resultado.facturacion.pagos[0].tipos_metodos_pagos_id;

      let suma_impuesto_rete = [];
      let suma_impuesto_tras = [];
      let suma_descuento = 0;
      let subtotal = 0;
      let total_descuento = 0;
      let total = 0;

      let grupos_impuestos = { Traslado: [], Retencion: [] };
      let todos_impuestos_t = [];
      let todos_impuestos_r = [];
      // conceptos
      resultado.facturacion.movimientos_articulos.forEach(elem => {
        let impuestos = elem.articulos.articulos_impuestos
          ? elem.articulos.articulos_impuestos.impuestos
          : { traslados: [], retenciones: [] };
        // importe del articulo
        elem.descuento = 0;
        let precio_unitario = 0;
        let importe = parseFloat(elem.importe);
        let impuesto_incluido = { Traslados: [], Retenciones: [] };
        // ver si se desglosa el impuesto, en caso contrario se agrega
        let descuento = 0; 
        if (this.desglosar_impuestos) {
          let desglosar = 0;
          let imp_des = 0;
          impuestos.traslados.forEach(el => {
            let impp = importe - importe / (1 + parseFloat(el.cuota));
            desglosar += parseFloat(impp.toFixed(2));
            imp_des += parseFloat(el.cuota);
          });

          impuestos.retenciones.forEach(el => {
            let impp = importe - importe / (1 + parseFloat(el.cuota));
            desglosar += parseFloat(impp.toFixed(2));
            imp_des += parseFloat(el.cuota);
          });

          descuento = parseFloat(elem.descuento) / (1 + imp_des);

          importe = parseFloat((importe - desglosar).toFixed(2));

          precio_unitario = parseFloat((importe / elem.cantidad).toFixed(2));
          suma_descuento += parseFloat(descuento.toFixed(2));
        } else {
          let sumar = 0;
          descuento = parseFloat(elem.descuento);
          importe = parseFloat((importe + sumar).toFixed(2));
          precio_unitario = parseFloat((importe / elem.cantidad).toFixed(2));

          suma_descuento += descuento;
          impuestos.traslados.forEach(el => {
            let summ = importe - importe / (1 + parseFloat(el.cuota));
            sumar += parseFloat(summ.toFixed(2));
          });

          impuestos.retenciones.forEach(el => {
            let summ = importe - importe / (1 + parseFloat(el.cuota));
            sumar += parseFloat(summ.toFixed(2));
          });
        }
        impuestos.traslados.forEach(el => {
          if (!suma_impuesto_tras[el.clave]) {
            suma_impuesto_tras[el.clave] = 0;
          }
          let importe_impuesto = parseFloat((importe - descuento).toFixed(2));
          let impp = parseFloat(
            (importe_impuesto * parseFloat(el.cuota)).toFixed(2)
          );
          suma_impuesto_tras[el.clave] += parseFloat(impp.toFixed(2));
          impuesto_incluido.Traslados.push({
            Traslado: {
              Base: importe_impuesto,
              Impuesto: el.clave,
              TipoFactor: el.factor,
              TasaOCuota: el.cuota,
              Importe: impp.toFixed(2)
            }
          });

          if (todos_impuestos_t.indexOf(el.clave) < 0) {
            todos_impuestos_t.push(el.clave);
            grupos_impuestos.Traslado.push(el);
          }
        });

        impuestos.retenciones.forEach(el => {
          if (!suma_impuesto_rete[el.clave]) {
            suma_impuesto_rete[el.clave] = 0;
          }
          let importe_impuesto = parseFloat((importe - descuento).toFixed(2));
          let impp = parseFloat(
            (importe_impuesto * parseFloat(el.cuota)).toFixed(2)
          );
          suma_impuesto_rete[el.clave] += parseFloat(impp.toFixed(2));
          impuesto_incluido.Retenciones.push({
            Retencion: {
              Base: importe_impuesto,
              Impuesto: el.clave,
              TipoFactor: el.factor,
              TasaOCuota: el.cuota,
              Importe: impp.toFixed(2)
            }
          });
          if (todos_impuestos_r.indexOf(el.clave) < 0) {
            todos_impuestos_r.push(el.clave);
            grupos_impuestos.Retencion.push(el);
          }
        });
        total_descuento += descuento;
        subtotal += importe;
        // conceptos con complemento educativo
        if (elem.precio_unitario > 0)
          if(impuesto_incluido.Retenciones.length <= 0)
            delete impuesto_incluido.Retenciones;
          if(impuesto_incluido.Traslados.length <= 0)
            delete impuesto_incluido.Traslados;
          this.facturacion.Conceptos.Concepto.push({
            ClaveProdServ: elem.articulos.clave_prod_serv,
            ClaveUnidad: elem.articulos.unidades_medidas.clave,
            NoIdentificacion: elem.articulos.sku,
            Cantidad: elem.cantidad,
            Unidad: elem.articulos.unidades_medidas.nombre,
            Descripcion: elem.articulos.nombre,
            ValorUnitario: precio_unitario.toFixed(2),
            PrecioReal: parseFloat(elem.precio_unitario),
            Descuento: 0,//descuento.toFixed(2),
            DescuentoReal: 0,//elem.descuento,
            Importe: importe.toFixed(2),
            Impuestos: impuesto_incluido,
            ComplementoConcepto: {
              version: "1.0",
              nombreAlumno:
                resultado.facturacion.personas.nombre +
                " " +
                resultado.facturacion.personas.apellido_paterno +
                " " +
                resultado.facturacion.personas.apellido_materno,
              CURP: resultado.facturacion.personas.curp,
              nivelEducativo:
                resultado.facturacion.personas.carrera.nivel_educativo,
              autRVOE: resultado.facturacion.personas.carrera.rvoe
            },
            iva: true
          });
      });
      let total_impuesto_tras = 0;
      let total_impuesto_rete = 0;

      grupos_impuestos.Traslado.forEach(el => {
        total_impuesto_tras += parseFloat(
          suma_impuesto_tras[el.clave].toFixed(2)
        );
        let traslado : any = {
          Impuesto: el.clave,
          TipoFactor: el.factor,
          
        };
        
          traslado.TasaOCuota = el.cuota;
          traslado.Importe = suma_impuesto_tras[el.clave].toFixed(2);
        
        this.facturacion.Impuestos.Traslados.push({
          Traslado: traslado
        });
      });
      grupos_impuestos.Retencion.forEach(el => {
        total_impuesto_rete += parseFloat(
          suma_impuesto_rete[el.clave].toFixed(2)
        );
        let retencion : any = {
          Impuesto: el.clave,
          TipoFactor: el.factor,
          
        };
        
          retencion.TasaOCuota = el.cuota;
          retencion.Importe = suma_impuesto_rete[el.clave].toFixed(2);
        
        this.facturacion.Impuestos.Retenciones.push({
          Retencion: retencion
        });
      });

      this.facturacion.Impuestos.TotalImpuestosTrasladados = total_impuesto_tras.toFixed(
        2
      );
      this.facturacion.Impuestos.TotalImpuestosRetenidos = total_impuesto_rete.toFixed(
        2
      );

      let T_Total = subtotal - total_descuento + (total_impuesto_tras + total_impuesto_rete);

      this.facturacion.SubTotal = T_Total.toFixed(2); //subtotal.toFixed(2);
      this.facturacion.Descuento = 0; //total_descuento.toFixed(2);
      this.facturacion.Total = T_Total.toFixed(2);

      this.recalcular_impuesto();
      document.getElementById("verPdf").classList.add("is-active");
    }
  }

  recalcular_impuesto() {
    this.facturacion.Impuestos = {
      Traslados: [],
      Retenciones: []
    };

    let posicion = 0;
    let total_total_impuesto_tras = 0;
    let total_total_impuesto_rete = 0;
    let total_subtotal = 0;
    let suma_impuesto_rete = [];
    let suma_impuesto_tras = [];
    let suma_descuento = 0;
    let subtotal = 0;
    let total_descuento = 0;
    let total = 0;
    // conceptos
    if (this.facturacion.Conceptos.Concepto) {
      let grupos_impuestos = { Traslado: [], Retencion: [] };
      let todos_impuestos_t = [];
      let todos_impuestos_r = [];
      this.facturacion.Conceptos.Concepto.forEach(elem => {
        let impuestos = elem.Impuestos;
        // importe del articulo
        let importe = elem.PrecioReal * elem.Cantidad;
        elem.ValorUnitario = elem.PrecioReal;
        let impuesto_incluido = {
          Traslados: [],
          Retenciones: []
        };
        // ver si se desglosa el impuesto, en caso contrario se agrega

        let precio_unitario = 0;
        let descuento = 0;
        if (elem.iva) {
          if (this.desglosar_impuestos) {
            let desglosar = 0;
            let imp_des = 0;
            impuestos.Traslados.forEach(elimp => {
              let el = elimp.Traslado;
              
              let impp = 0;
              if( el.TasaOCuota > 0)
                impp = importe - importe / (1 + el.TasaOCuota);
              desglosar += parseFloat(impp.toFixed(2));

              imp_des += el.TasaOCuota ? el.TasaOCuota : 0;
              
              if (todos_impuestos_t.indexOf(el.Impuesto) < 0) {
                todos_impuestos_t.push(el.Impuesto);
                grupos_impuestos.Traslado.push(el);
              }
            });

            impuestos.Retenciones.forEach(elimp => {
              let el = elimp.Retencion;
              let impp = 0;
              if( el.TasaOCuota > 0)
                impp = importe - importe / (1 + el.TasaOCuota);
              desglosar += parseFloat(impp.toFixed(2));

              imp_des += el.TasaOCuota ? el.TasaOCuota : 0;
              
              if (todos_impuestos_r.indexOf(el.Impuesto) < 0) {
                todos_impuestos_r.push(el.Impuesto);
                grupos_impuestos.Retencion.push(el);
              }
            });
            descuento = parseFloat(elem.DescuentoReal) / (1 + imp_des);

            importe = parseFloat((importe - desglosar).toFixed(2));

            precio_unitario = parseFloat((importe / elem.Cantidad).toFixed(2));
            suma_descuento += parseFloat(descuento.toFixed(2));
          } else {
            let sumar = 0;
            descuento = parseFloat(elem.DescuentoReal);
            importe = parseFloat((importe + sumar).toFixed(2));
            precio_unitario = parseFloat((importe / elem.Cantidad).toFixed(2));

            suma_descuento += descuento;
            impuestos.Traslados.forEach(elimp => {
              let el = elimp.Traslado;
              let summ = 0;
              if( el.TasaOCuota > 0)
                summ = importe - importe / (1 + el.TasaOCuota);
              sumar += parseFloat(summ.toFixed(2));
            });

            impuestos.Retenciones.forEach(elimp => {
              let el = elimp.Retencion;
              let summ = 0;
              if( el.TasaOCuota > 0)importe - importe / (1 + el.TasaOCuota);
                sumar += parseFloat(summ.toFixed(2));
            });
          }

          total_descuento += descuento;
          subtotal += importe;

          if (this.con_impuesto) {
            impuesto_incluido.Traslados = [];
            impuestos.Traslados.forEach(elimp => {
              let el = elimp.Traslado;
              if (!suma_impuesto_tras[el.Impuesto]) {
                suma_impuesto_tras[el.Impuesto] = 0;
              }
              suma_impuesto_tras[el.Impuesto] += (importe - descuento) * (el.TasaOCuota ? el.TasaOCuota : 0);
              let traslado : any = {
                Base: (importe - descuento).toFixed(2),
                Impuesto: el.Impuesto,
                TipoFactor: el.TipoFactor,
                
              };
              
                traslado.TasaOCuota = el.TasaOCuota;
                traslado.Importe = ((importe - descuento) * el.TasaOCuota).toFixed(2);
              
  
              
              impuesto_incluido.Traslados.push({
                Traslado: traslado
              });
            });

            impuesto_incluido.Retenciones = [];
            impuestos.Retenciones.forEach(elimp => {
              let el = elimp.Retencion;
              if (!suma_impuesto_rete[el.Impuesto]) {
                suma_impuesto_rete[el.Impuesto] = 0;
              }
              suma_impuesto_rete[el.Impuesto] += (importe - descuento) * (el.TasaOCuota ? el.TasaOCuota : 0);

              let retencion : any = {
                Base: (importe - descuento).toFixed(2),
                Impuesto: el.Impuesto,
                TipoFactor: el.TipoFactor,
                
              };
              
                retencion.TasaOCuota = el.TasaOCuota;
                retencion.Importe = ((importe - descuento) * el.TasaOCuota).toFixed(2);
              

              impuesto_incluido.Retenciones.push({
                Retencion: retencion
              });
            });
          }
        } else {
          descuento = parseFloat(elem.DescuentoReal);
          importe = parseFloat(elem.ValorUnitario) * elem.Cantidad;
          precio_unitario = parseFloat(elem.ValorUnitario);

          total_descuento += descuento;
          subtotal += importe;
        }


        let ComplementoConcepto = this.facturacion.Conceptos.Concepto[posicion].ComplementoConcepto;
        
        let iva = this.facturacion.Conceptos.Concepto[posicion].iva;
        this.facturacion.Conceptos.Concepto[posicion] = {
          ClaveProdServ: elem.ClaveProdServ,
          ClaveUnidad: elem.ClaveUnidad,
          NoIdentificacion: elem.NoIdentificacion,
          Cantidad: elem.Cantidad,
          Unidad: elem.Unidad,
          Descripcion: elem.Descripcion,
          ValorUnitario: precio_unitario.toFixed(2),
          PrecioReal: elem.PrecioReal,
          Descuento: 0,
          DescuentoReal: 0,
          Importe: (parseFloat(elem.Cantidad) * precio_unitario).toFixed(2),
          ComplementoConcepto: ComplementoConcepto,
          iva: iva
        };

        total_subtotal += parseFloat(elem.Cantidad) * precio_unitario;

        if (this.con_impuesto) {
          this.facturacion.Conceptos.Concepto[
            posicion
          ].Impuestos = impuesto_incluido;
        }
        posicion++;
      });

      if (this.con_impuesto) {
        grupos_impuestos.Traslado.forEach(el => {
          if (suma_impuesto_tras[el.Impuesto]) {
            total_total_impuesto_tras += suma_impuesto_tras[el.Impuesto];

            let traslado : any = {
              Impuesto: el.Impuesto,
              TipoFactor: el.TipoFactor,
              
            };
            
              traslado.TasaOCuota = el.cuota;
              traslado.Importe = suma_impuesto_tras[el.Impuesto].toFixed(2);
            

            this.facturacion.Impuestos.Traslados.push({
              Traslado: traslado
            });
          }
        });
        grupos_impuestos.Retencion.forEach(el => {
          if (suma_impuesto_rete[el.Impuesto]) {
            total_total_impuesto_rete += suma_impuesto_rete[el.Impuesto];

            let retencion : any = {
              Impuesto: el.Impuesto,
              TipoFactor: el.TipoFactor,
              
            };
            
              retencion.TasaOCuota = el.TasaOCuota;
              retencion.Importe = suma_impuesto_rete[el.Impuesto].toFixed(2);
            

            this.facturacion.Impuestos.Retenciones.push({
              Retencion: retencion
            });
          }
        });

        this.facturacion.Impuestos.TotalImpuestosTrasladados = total_total_impuesto_tras.toFixed(
          2
        );
        this.facturacion.Impuestos.TotalImpuestosRetenidos = total_total_impuesto_rete.toFixed(
          2
        );
      }

      let gran_total =
        total_subtotal -
        total_descuento +
        (total_total_impuesto_tras + total_total_impuesto_rete);

      this.facturacion.SubTotal = gran_total.toFixed(2);//total_subtotal.toFixed(2);
      this.facturacion.Descuento = 0;//total_descuento.toFixed(2);
      this.facturacion.Total = gran_total.toFixed(2);
    }
  }

  timbrar() {
    document.getElementById("confirmarTimbrar").classList.remove("is-active");
    this.cargando = true;
    let json: any = this.facturacion;
    this.error_timbre = false;
    this.crudService.crear(json, this.CFDI_PATH + "/api/v1/facturar").subscribe(
      resultado => {
        this.cargando = false;
        if (resultado.status === 201) {
          // datos de respuesta del pac
          let resupuesta = resultado.data;
          // obtener los datos de regreso de la api para la factura
          this.facturacion = resultado.json;

          // guardar la factura local para consultas posteriores
          this.guardar_factura(resultado);

          setTimeout(() => {
            document.getElementById("imprimir_pdf").click();
          }, 250);
        } else {
          if (resultado.messages.errores) {
            this.errores = resultado.messages.errores;
            setTimeout(() => {
              this.errores = [];
            }, 3500 * this.errores.length);
          } else {
            this.sin_resultado = resultado.messages;
            setTimeout(() => {
              this.sin_resultado = "";
            }, 3000);
          }
        }
      },
      error => {
        this.cargando = false;
        this.error_timbre = true;
        setTimeout(() => {
          this.error_timbre = false;
        }, 3500);
      }
    );
  }

  guardar_factura(respuesta) {
    respuesta["ventas"] = this.ventas_facturar;
    this.crudService
      .crear(respuesta, "factura")
      .subscribe(resultado => {
        this.ventas_facturar = [];
      }, error => {});
  }

  quita_poner_iva(item) {
    item.iva = !item.iva;

    if (item.iva) {
      let suma_impuesto_rete = [];
      let suma_impuesto_tras = [];

      let impuesto_incluido = {
        Traslados: [],
        Retenciones: []
      };

      let impuestos = this.configuracion.sucursal.impuestos;
      let desglosar = 0;
      let imp_des = 0;

      impuestos.traslados.forEach(el => {
        let impp =
          item.precio_unitario -
          item.precio_unitario / (1 + parseFloat(el.cuota));
        desglosar += parseFloat(impp.toFixed(2));
        imp_des += parseFloat(el.cuota);
      });

      impuestos.retenciones.forEach(el => {
        let impp =
          item.precio_unitario -
          item.precio_unitario / (1 + parseFloat(el.cuota));
        desglosar += parseFloat(impp.toFixed(2));
        imp_des += parseFloat(el.cuota);
      });

      impuestos.traslados.forEach(el => {
        if (!suma_impuesto_tras[el.clave]) {
          suma_impuesto_tras[el.clave] = 0;
        }
        let importe_impuesto = parseFloat(
          (item.importe - item.descuento).toFixed(2)
        );
        let impp = parseFloat(
          (importe_impuesto * parseFloat(el.cuota)).toFixed(2)
        );
        suma_impuesto_tras[el.clave] += parseFloat(impp.toFixed(2));
        impuesto_incluido.Traslados.push({
          Traslado: {
            Base: importe_impuesto,
            Impuesto: el.clave,
            TipoFactor: el.factor,
            TasaOCuota: el.cuota,
            Importe: impp.toFixed(2)
          }
        });
      });

      impuestos.retenciones.forEach(el => {
        if (!suma_impuesto_rete[el.clave]) {
          suma_impuesto_rete[el.clave] = 0;
        }
        let importe_impuesto = parseFloat(
          (item.importe - item.descuento).toFixed(2)
        );
        let impp = parseFloat(
          (importe_impuesto * parseFloat(el.cuota)).toFixed(2)
        );
        suma_impuesto_rete[el.clave] += parseFloat(impp.toFixed(2));
        impuesto_incluido.Retenciones.push({
          Retencion: {
            Base: importe_impuesto,
            Impuesto: el.clave,
            TipoFactor: el.factor,
            TasaOCuota: el.cuota,
            Importe: impp.toFixed(2)
          }
        });
      });

      item.Impuestos = impuesto_incluido;
    } else {
      delete item.Impuestos;
    }
    this.recalcular_impuesto();
  }
  generar_factura(factura){
    this.facturacion = factura;
    setTimeout(() => {
      document.getElementById("recibos").classList.remove("is-active");
      document.getElementById("verPdf").classList.add("is-active");
    }, 100);
  }

  pagos_publicos = [];
  parametros = {
    pagina: 0,
    limite: 0
  };
  listarBusqueda(term: string): void {
    this.total = 0;
    this.cargando = true;

    this.parametros.pagina = 0;
    this.parametros.limite = 1000;
    this.crudService
      .lista(
        this.parametros,
        "pago-publico?columna=&valor=" +
          term +
          "&buscar=true&pagina=0&limite=1500"
      )
      .subscribe(
        resultado => {
          this.cargando = false;
          this.pagos_publicos = resultado.data as any[];
        },
        error => {}
      );
  }
  seleccione_colegiatura = "";

  asignarPagoPublico(item) {
    const pago = <FormArray>this.dato.controls.pagos;
    this.dato.controls.cuentas_bancarias_id.patchValue(
      item.cuentas_bancarias_id
    );
    if (pago.controls[0]["controls"]["importe"].value > 0) {
      this.dato.controls.pagos_publicos_id.patchValue(item.id);
      pago.controls[0]["controls"]["paga_con"].patchValue(item.cantidad);

      document.getElementById("pagosPublicos").classList.remove("is-active");
      this.calcular_importe_articulo();
    } else {
      this.seleccione_colegiatura =
        "Porfavor... primero agregue un concepto de cobro";
      setTimeout(() => {
        this.seleccione_colegiatura = "";
      }, 3000);
    }
  }

  quitarPagosPublicos() {
    this.dato.controls.pagos_publicos_id.patchValue("");
    const pago = <FormArray>this.dato.controls.pagos;
    if (pago.length) pago.controls[0]["controls"]["paga_con"].patchValue("");
    this.calcular_importe_articulo();
  }

  asignarPagoCuenta() {
    const pago = <FormArray>this.dato.controls.pagos;

    if (pago.controls[0]["controls"]["importe"].value > 0) {
      let total_pago = 0;
      if (
        this.alumnos.saldo_cuenta >
        pago.controls[0]["controls"]["importe"].value
      ) {
        total_pago = parseFloat(pago.controls[0]["controls"]["importe"].value);
      } else {
        total_pago = this.alumnos.saldo_cuenta;
      }
      this.alumnos.saldo_cuenta = this.alumnos.saldo_cuenta - total_pago;
      this.dato.controls.pagos_cuentas.patchValue(total_pago);
      pago.controls[0]["controls"]["paga_con"].patchValue(total_pago);
      pago.controls[0]["controls"]["tipos_formas_pagos_id"].patchValue("06");

      this.calcular_importe_articulo();
    } else {
      this.seleccione_colegiatura =
        "Porfavor... primero agregue un concepto de cobro";
      setTimeout(() => {
        this.seleccione_colegiatura = "";
      }, 3000);
    }
  }
  quitarPagoCuenta() {
    this.alumnos.saldo_cuenta += parseFloat(
      this.dato.controls.pagos_cuentas.value
    );
    this.dato.controls.pagos_cuentas.patchValue(0);
    const pago = <FormArray>this.dato.controls.pagos;
    if (pago.length) pago.controls[0]["controls"]["paga_con"].patchValue("");
    this.calcular_importe_articulo();
  }

  tickets = {
    precio: 0,
    descuento: 0,
    total_abonado: 0,
    recargo: 0,
    movimientos_tikets: []
  };
  mostrarAbonos(item, pos, tipo) {
    this.tickets = item;
    if (tipo == 2)
      this.tickets["movimientos_tikets"] = item.movimientos_colegiaturas;
    else this.tickets["movimientos_tikets"] = item.movimientos_inscripciones;
    document.getElementById("recibos").classList.add("is-active");
  }

  elemento_eliminar = null;
  confirmar_eliminar(val) {
    this.elemento_eliminar = val;
    document.getElementById("cancelacion").classList.add("is-active");
  }

  eliminar_ticket() {
    this.cargando = true;
    this.crudService.eliminar(this.elemento_eliminar.id, "pago").subscribe(
      data => {
        if(data.status == 200){
          document.getElementById("cancelacion").classList.remove("is-active");
          document.getElementById("recibos").classList.remove("is-active");
          document.getElementById("cargar_datos_actualizar").click();
        }else{
          this.cargando = false;
        }
      },
      error => {
        this.cargando = false;
      }
    );
  }

  limpiar_fecha(modelo, i, pos){
    modelo.created_at = '';
    this.recalcular_dias(modelo, i, pos);
  }

  asignar_fecha(event, modelo) {
    modelo.created_at = event.srcElement.value;
  }

  recalcular_dias(modelo, i, pos){
    let json: any = {
      beca: modelo.beca,
      beca_promedio: modelo.beca_promedio,
      beca_porcentaje: modelo.beca_porcentaje,
      fecha_nueva: modelo.created_at,
      fecha_pago: modelo.fecha_pago,
      planes_recargos_id: modelo.recargos.planes_recargos_id,
      planes_pagos_id: modelo.planes_pagos_id,
      beca_asignada: modelo.beca_asignada
    };

    this.cargando = true;
    this.crudService.crear(json, "cambiar-fecha-pago").subscribe(
      resultado => {
        this.cargando = false;
        if (resultado.status === 200) {
          modelo.recargo_es_porcentaje = resultado.data.recargo_es_porcentaje;
          modelo.recargo_importe = resultado.data.recargo_importe;
          modelo.dias = resultado.data.dias;
          modelo.recargos = resultado.data.recargos;

          modelo.beca = resultado.data.beca;
          modelo.beca_porcentaje = resultado.data.beca_porcentaje;
        }
      },
      error => {
        this.cargando = false;
      }
    );
  }
  logo;
  logo_sucursal;
  logo_empresa;
  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos.sucursal;
      this.logo_empresa = logos.empresa;
      this.logo = this.logo_sucursal != "" ? this.logo_sucursal : this.logo_empresa;
    }
  }

  asignarPersona(){
    //this.dato.controls.personas_id.patchValue(this.alumnos.id);
    setTimeout(() => {
      document.getElementById("asignarPersona").click();
    }, 200)

  }
  convertirMoneda(importe) {
    return (new CurrencyPipe('en')).transform(importe, this.configuracion.sucursal.moneda, true);
  }
}
